import * as React from 'react';
import '../css/bug-view.sass';

interface ChannelBugViewProps {
  imgName: string;
  callLetter: string;
  number?: string;
  theme?: 'night' | 'day';
}

export default function ChannelBugView(props: ChannelBugViewProps) {
  const { theme = 'day' } = props;
  return (
    <div className={`guide-logo ${theme}`}>
      <img alt={`${props.callLetter}`} src={props.imgName} />
      <div className="channel-info">
        <span className="call-letter">{props.callLetter}</span>
        {props.number && (
          <span className="channel-number">
            <span className="bullet">•</span>
            <span>{props.number}</span>
          </span>
        )}
      </div>
    </div>
  );
}
